import request from '../../utils/requests'
/** * Tag: TeacherStatistics */
const baseUrl ="/api/TeacherStatistics";

/** * 获取某老师课消统计(按课程分组) * @param {*} body * { *    UserId Desc:老师ID Required:false *    BranchId Desc:校区ID Required:false *    CourseId Desc:课程ID Required:false *    StartDate Desc:开始日期 Required:false *    EndDate Desc:结束日期 Required:false *    OrgId Desc:机构Id(后台使用) Required:false * } */async function _getTeacherScheduleStatistics(body) {  return request(baseUrl+'/getTeacherScheduleStatistics',{    method: 'POST',    body: body,  });
}

export default{  _getTeacherScheduleStatistics}



// WEBPACK FOOTER //
// ./src/services/teacherStatistics.js